<div class="settings-page">

  <app-page-header
    title="Support Settings"
    subtitle="Manage ticket categories and support configuration"
    [showBackButton]="true"
    backRoute="/help/tickets"
    backLabel="Back to Inbox">
    <button class="btn-primary"
      type="button"
      (click)="showAddForm = true"
      *ngIf="!showAddForm">
      + Add Category
    </button>
  </app-page-header>

  <!-- Add category form -->
  <div class="settings-card" *ngIf="showAddForm">
    <h3>Add New Category</h3>

    <div class="form-grid">
      <div class="form-group">
        <label class="form-label">
          Category Key *
        </label>
        <input type="text" class="form-input"
          [(ngModel)]="newCategory.value"
          name="newCategoryValue"
          placeholder="e.g. billing_dispute"
          (input)="onCategoryKeyInput($event)">
        <small class="form-hint">
          Lowercase letters and underscores only.
          Cannot be changed after saving.
        </small>
      </div>

      <div class="form-group">
        <label class="form-label">Label *</label>
        <input type="text" class="form-input"
          [(ngModel)]="newCategory.label"
          name="newCategoryLabel"
          placeholder="Billing Dispute">
      </div>

      <div class="form-group">
        <label class="form-label">
          Description
        </label>
        <input type="text" class="form-input"
          [(ngModel)]="newCategory.description"
          name="newCategoryDescription"
          placeholder="Short description for users">
      </div>

      <div class="form-group">
        <label class="form-label">Routes To</label>
        <mat-form-field appearance="outline"
          class="support-select"
          subscriptSizing="dynamic">
          <mat-select
            [(ngModel)]="newCategory.routes_to"
            name="newCategoryRoutesTo"
            panelClass="owner-station-filter-panel">
            <mat-option value="admin">Admin</mat-option>
            <mat-option value="station">Station</mat-option>
          </mat-select>
        </mat-form-field>
        <small class="form-hint">
          Admin: routes to RAD team.
          Station: routes to station staff.
        </small>
      </div>
    </div>

    <p class="help-form-error" *ngIf="formError">
      {{ formError }}
    </p>

    <div class="settings-form-actions">
      <button class="btn-secondary"
        type="button"
        (click)="showAddForm=false; formError=''">
        Cancel
      </button>
      <button class="btn-primary"
        type="button"
        (click)="saveNewCategory()"
        [disabled]="isSaving">
        <span class="btn-spinner"
          *ngIf="isSaving"></span>
        {{ isSaving ? 'Saving...' : 'Save Category' }}
      </button>
    </div>
  </div>

  <!-- Categories list -->
  <div class="settings-card">
    <h3>Ticket Categories</h3>
    <p class="settings-hint">
      Categories appear in the issue dropdown
      when users submit tickets.
      Inactive categories are hidden from users.
    </p>

    <div class="settings-loader" *ngIf="loading">
      <app-data-loader [show]="true"
        message="Loading categories..."
        size="medium" />
    </div>

    <div class="settings-empty"
      *ngIf="!loading && categories.length === 0">
      <mat-icon>category</mat-icon>
      <p>No categories yet. Add one to get started.</p>
    </div>

    <div class="category-list" *ngIf="!loading && categories.length > 0">
      <div class="category-item"
        *ngFor="let cat of categories"
        [class.category-item--inactive]="!isCategoryActive(cat)">

        <div class="category-item__info">
          <div class="category-item__label">
            {{ cat.label }}
            <span class="category-key">
              {{ cat.value }}
            </span>
          </div>
          <div class="category-item__desc">
            {{ cat.description }}
          </div>
          <div class="category-item__meta">
            <span [class]="'route-badge route-badge--' + cat.routes_to">
              Routes to: {{ cat.routes_to }}
            </span>
            <span class="active-badge"
              *ngIf="isCategoryActive(cat)">
              Active
            </span>
            <span class="inactive-badge"
              *ngIf="!isCategoryActive(cat)">
              Inactive
            </span>
          </div>
        </div>

        <div class="category-item__actions">
          <button class="btn-secondary btn-sm"
            type="button"
            (click)="startEdit(cat)">
            Edit
          </button>
          <label class="rad-toggle"
            [attr.title]="isCategoryActive(cat) ? 'Deactivate' : 'Activate'">
            <input type="checkbox"
              [checked]="isCategoryActive(cat)"
              (change)="toggleCategoryActive(cat)">
            <span class="rad-toggle-slider"></span>
          </label>
        </div>
      </div>
    </div>
  </div>

  <!-- Edit modal -->
  <div class="modal-overlay"
    *ngIf="editingCategory"
    (click)="editingCategory=null">
    <div class="modal-content"
      (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>Edit Category</h3>
        <button class="modal-close"
          type="button"
          aria-label="Close"
          (click)="editingCategory=null">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="form-group">
        <label class="form-label">Label</label>
        <input type="text" class="form-input"
          [(ngModel)]="editingCategory.label"
          name="editLabel">
      </div>
      <div class="form-group">
        <label class="form-label">Description</label>
        <input type="text" class="form-input"
          [(ngModel)]="editingCategory.description"
          name="editDescription">
      </div>
      <div class="form-group">
        <label class="form-label">Routes To</label>
        <mat-form-field appearance="outline"
          class="support-select"
          subscriptSizing="dynamic">
          <mat-select
            [(ngModel)]="editingCategory.routes_to"
            name="editRoutesTo"
            panelClass="owner-station-filter-panel">
            <mat-option value="admin">Admin</mat-option>
            <mat-option value="station">Station</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="modal-actions">
        <button class="btn-secondary"
          type="button"
          (click)="editingCategory=null">
          Cancel
        </button>
        <button class="btn-primary"
          type="button"
          (click)="saveEditCategory()"
          [disabled]="isSaving">
          Save Changes
        </button>
      </div>
    </div>
  </div>
</div>
